import { buildForm, KitchenSinkRoute, RouteSlotInput } from '@luks/ui';
import { bind } from '@react-rxjs/core';
import { createSignal } from '@react-rxjs/utils';
import { debounceTime } from 'rxjs';

import { formNavigate } from '../../commons/forms';
import { useSearchSuggestions } from '../../commons/search-suggestions';

const [queryInputChanges$, setQueryInput] = createSignal<string>();

const [useQueryInput] = bind(queryInputChanges$.pipe(debounceTime(200)), '');

const Form = buildForm<{ query: string }>({
  initialValues: {
    query: '',
  },
  onSubmit: formNavigate('/site-search'),
  onChange: (values) => values.query && setQueryInput(values.query),
});

export const mapSiteSearch = ({
  placeholderText,
}: SiteSearchFragment): RouteSlotInput<
  typeof KitchenSinkRoute,
  'body',
  'SearchForm'
> => {
  return {
    key: 'SearchForm',
    input: function useSiteSearch() {
      const { status, suggestions } = useSearchSuggestions(useQueryInput());
      return [
        {
          Form,
          placeholderText,
          suggestions,
        },
        status,
      ];
    },
  };
};
